import { useContext } from "react";
import { Link } from "react-router-dom";

import { AuthContext } from "src/context/authContext";
import { FooterContext } from "src/context/footerContext";



const Footer = () => {
  const { isUserAuthorized, isManufacturer } = useContext(AuthContext);
  const { isAccordianShown, changeAccordianVisibility } = useContext(FooterContext);

  return (
    <footer className="sticky-bottom">
      <div className="accordion prescribing-accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button onClick={changeAccordianVisibility} className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
              Please see important information and full prescribing information
              {isAccordianShown ? (
                <i className="bi bi-chevron-down ps-1"></i>
              ) : (
                <i className="bi bi-chevron-up ps-1"></i>
              )}
            </button>
          </h2>
          <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div className="accordion-body ps-2 pe-2">
              <div className="container">
                <h3 className="text-secondary">Important Notice</h3>
                <p>This site is intended to provide medical and product information to health care professionals in the
                  United States.</p>
                <p>To report an adverse event, email <a href="mailto:drugsafety@pacira.com">drugsafety@pacira.com</a> or
                  call <a href="tel:+18444626225">1-855-793-9727</a>.</p>
                <p>For medical inquiries related to EXPAREL, submit a <a
                  href="https://www.exparelpro.com/medical-inquiries" target="_blank">request to Medical
                  Information</a>. or call <a href="tel:+18444626225">1-855-793-9727</a>.</p>
                <p>These are not all of the potential important safety considerations for EXPAREL; please see the
                  full <a href="https://www.exparelpro.com/prescribing-information.pdf" target="_blank">Prescribing
                    Information</a>.</p>


                <h3 className="text-secondary">Indication</h3>
                <p>EXPAREL® (bupivacaine liposome injectable suspension) is indicated to produce postsurgical local
                  analgesia via infiltration in patients aged 6 years and older and regional analgesia in adults via an
                  interscalene brachial plexus nerve block, sciatic nerve block in the popliteal fossa, and an adductor
                  canal block. Safety and efficacy have not been established in other nerve blocks.</p>

                <h3 className="text-secondary">Important Safety Information</h3>
                <p>EXPAREL is contraindicated in obstetrical paracervical block anesthesia.</p>
                <p>Adverse reactions reported in adults with an incidence greater than or equal to 10% following EXPAREL
                  administration via infiltration were nausea, constipation, and vomiting; adverse reactions reported in
                  adults with an incidence greater than or equal to 10% following EXPAREL administration via nerve block
                  were nausea, pyrexia, headache, and constipation.</p>
                <p>Adverse reactions with an incidence greater than or equal to 10% following EXPAREL administration via
                  infiltration in pediatric patients six to less than 17 years of age were nausea, vomiting,
                  constipation, hypotension, anemia, muscle twitching, vision blurred, pruritus, and tachycardia.</p>
                <p>Do not admix lidocaine or other non-bupivacaine local anesthetics with EXPAREL. EXPAREL may be
                  administered at least 20 minutes or more following local administration of lidocaine.</p>
                <p>EXPAREL is not recommended to be used in the following patient populations: patients {'<6'} years old
                  for infiltration, patients younger than 18 years old for nerve blocks, and/or pregnant patients.</p>
                <p>Because amide-type local anesthetics, such as bupivacaine, are metabolized by the liver, EXPAREL
                  should be used cautiously in patients with hepatic disease.</p>

                <h3 className="text-secondary">Warnings and Precautions Specific to EXPAREL</h3>
                <ul>
                  <li>Avoid additional use of local anesthetics within 96 hours following administration of EXPAREL.
                  </li>
                  <li>EXPAREL is not recommended for the following types or routes of administration: epidural,
                    intrathecal, regional nerve blocks other than interscalene brachial plexus nerve block, sciatic
                    nerve block in the popliteal fossa, and adductor canal block, or intravascular or intra-articular
                    use.
                  </li>
                  <li>The potential sensory and/or motor loss with EXPAREL is temporary and varies in degree and
                    duration depending on the site of injection and dosage administered and may last for up to 5 days,
                    as seen in clinical trials.
                  </li>
                </ul>


                <h3 className="text-secondary">Warnings and Precautions for Bupivacaine-Containing Products</h3>
                <ul>
                  <li><strong>Central Nervous System (CNS) Reactions:</strong> There have been reports of adverse
                    neurologic reactions with the use of local anesthetics. These include persistent anesthesia and
                    paresthesia. CNS reactions are characterized by excitation and/or depression.
                  </li>
                  <li><strong>Cardiovascular System Reactions:</strong> Toxic blood concentrations depress cardiac
                    conductivity and excitability, which may lead to dysrhythmias, sometimes leading to death.
                  </li>
                  <li><strong>Allergic Reactions:</strong> Allergic-type reactions (eg, anaphylaxis and angioedema) are
                    rare and may occur as a result of hypersensitivity to the local anesthetic or to other formulation
                    ingredients.
                  </li>
                  <li><strong>Chondrolysis:</strong> There have been reports of chondrolysis (mostly in the shoulder
                    joint) following intra-articular infusion of local anesthetics, which is an unapproved use.
                  </li>
                  <li><strong>Methemoglobinemia:</strong> Cases of methemoglobinemia have been reported with local
                    anesthetic use.
                  </li>
                </ul>

                <p>
                  Please refer to full&nbsp;
                  <a href="https://www.exparelpro.com/prescribing-information.pdf" target="_blank">Prescribing
                    Information</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
